import { ListStickyNotesQueryVariables } from '@akin-home/amplify';
import {
  listAllStickyNotesQuery,
  stickyNoteGraphqlToModel,
} from '@akin-home/sticky-notes/frontend';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

interface Params {
  params?: ListStickyNotesQueryVariables;
  options?: any;
}

const useListStickyNotesQuery = ({ params, options }: Params) =>
  useQuery(
    params ? ['sticky-notes', params] : 'sticky-notes',
    () => listAllStickyNotesQuery(params),
    options
  );

export const useListStickyNotes = (params: Params) => {
  const { data, ...results } = useListStickyNotesQuery(params);

  const sticky_notes = useMemo(() => {
    if (!data) return [];

    return data.map(stickyNoteGraphqlToModel);
  }, [data]);

  return {
    sticky_notes: sticky_notes || [],
    ...results,
  };
};

export const useListHabitatStickyNotes = (habitatID: string) => {
  return useListStickyNotes({
    params: { filter: { habitatID: { eq: habitatID } } },
  });
};
